import { Stack, Typography } from "@mui/material";
import CasinoIcon from "@mui/icons-material/Casino";
import PetsIcon from "@mui/icons-material/Pets";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";

interface IndustryIconConfig {
  icon: JSX.Element;
  color: string;
}

// Icon per industry_name, matching the Figma "industry_name -> Icon"
// reference table. Industries not listed there (Finance loans, Gambling,
// Seo Sport, ...) render with no icon, same as the reference table.
const INDUSTRY_ICONS: Record<string, IndustryIconConfig> = {
  bingo: { icon: <PanoramaFishEyeIcon fontSize="inherit" />, color: "#E91E8C" },
  casino: { icon: <CasinoIcon fontSize="inherit" />, color: "#D32F2F" },
  "pet food delivery": { icon: <PetsIcon fontSize="inherit" />, color: "#1976D2" },
  saas: { icon: <WarningAmberIcon fontSize="inherit" />, color: "#ED6C02" },
  sport: { icon: <SportsSoccerIcon fontSize="inherit" />, color: "#2E7D32" },
};

interface Props {
  industryName?: string | null;
}

// Shown under the brand name in Brand Name cells across all three Brands
// tables (All Brands / Needs Configuration / Not Connected).
const IndustryBadge = ({ industryName }: Props) => {
  if (!industryName) return null;
  const config = INDUSTRY_ICONS[industryName.trim().toLowerCase()];

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      {config && (
        <span style={{ display: "flex", fontSize: "18px", color: config.color }}>
          {config.icon}
        </span>
      )}
      <Typography fontSize="14px" color="text.secondary">
        {industryName}
      </Typography>
    </Stack>
  );
};

export default IndustryBadge;
